import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'wouter';
import api from '../lib/api';
import { ArrowLeft, GraduationCap, Award, ChevronRight } from 'lucide-react';

interface PathProgress {
  path_id: string;
  path_name: string;
  total_modules: number;
  completed_modules: number;
  certificate_code: string | null;
  certified_at: string | null;
}

export default function Training() {
  const [, setLocation] = useLocation();

  const { data: progress, isLoading } = useQuery({
    queryKey: ['training-progress'],
    queryFn: () => api.get('/training/my-progress').then(r => r.data.data as PathProgress[]),
  });

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <header className="bg-indigo-600 text-white p-4 pb-6">
        <div className="flex items-center gap-3 mb-3">
          <button onClick={() => setLocation('/')} className="p-1">
            <ArrowLeft className="h-6 w-6" />
          </button>
          <h1 className="text-xl font-bold">Treinamentos</h1>
        </div>
        <p className="text-indigo-200 text-sm">Trilhas de aprendizado e certificações</p>
      </header>

      <div className="flex-1 p-4 -mt-2 space-y-3">
        {isLoading ? (
          <div className="flex justify-center py-12">
            <div className="h-8 w-8 rounded-full border-4 border-indigo-500 border-t-transparent animate-spin" />
          </div>
        ) : (!progress || progress.length === 0) ? (
          <div className="text-center py-12">
            <GraduationCap className="h-12 w-12 mx-auto mb-3 text-gray-300" />
            <p className="text-gray-500">Nenhuma trilha disponível</p>
          </div>
        ) : (
          progress.map((path) => {
            const pct = path.total_modules > 0 ? Math.round((path.completed_modules / path.total_modules) * 100) : 0;
            return (
              <button
                key={path.path_id}
                onClick={() => setLocation(`/training/${path.path_id}`)}
                className="w-full bg-white rounded-xl border p-4 text-left active:scale-[0.98] transition-transform"
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-semibold text-gray-900">{path.path_name}</h3>
                      {path.certificate_code && (
                        <span className="flex items-center gap-1 text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full">
                          <Award className="h-3 w-3" /> Certificado
                        </span>
                      )}
                    </div>
                    <p className="text-sm text-gray-500 mt-1">{path.completed_modules}/{path.total_modules} módulos</p>
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-300 mt-1" />
                </div>
                <div className="mt-3">
                  <div className="flex justify-between text-xs text-gray-400 mb-1">
                    <span>Progresso</span>
                    <span>{pct}%</span>
                  </div>
                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full transition-all ${path.certificate_code ? 'bg-yellow-500' : 'bg-indigo-500'}`}
                      style={{ width: `${pct}%` }}
                    />
                  </div>
                </div>
              </button>
            );
          })
        )}
      </div>
      <div className="h-20" />
    </div>
  );
}
